/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AssignExperimentGroupsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AuthenticationContainer_user$ref: FragmentReference;
export type AuthenticationContainer_user = {|
  +id: string,
  +email: ?string,
  +username: ?string,
  +$fragmentRefs: AssignExperimentGroupsContainer_user$ref,
  +$refType: AuthenticationContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AuthenticationContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AssignExperimentGroupsContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '57598014cbc7780de40eeb6ab67baff2';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Authentication/__generated__/AuthenticationContainer_user.graphql.js